// extracted by mini-css-extract-plugin
module.exports = {"wrap":"NextAndPrevRecordButton__wrap--5cPa5","prev":"NextAndPrevRecordButton__prev--3tIxv","next":"NextAndPrevRecordButton__next--2tzt2"};